import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, inject, Injectable } from '@angular/core';
import { ErrorTrackerService } from '../services/error-tracker/error-tracker.service';

@Injectable({ providedIn: 'root' })
export class CustomErrorHandler implements ErrorHandler {
  private readonly errorTrackerService = inject(ErrorTrackerService);

  handleError(error: Error): void {
    if (!(error instanceof HttpErrorResponse)) {
      this.errorTrackerService.captureException(error);
    }
  }
}
